import { withInstall } from "../utils/index.mjs";
import _Col from "./Col.mjs";
const Col = withInstall(_Col);
var stdin_default = Col;
import { colProps } from "./Col.mjs";
export {
  Col,
  colProps,
  stdin_default as default
};
